import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { JobsServiceProvider } from '../../api/jobs'

const JobsService = JobsServiceProvider()
const nameJob = 'deleteJob'

export default (name) => (asyncAction(
  nameJob,
  JobsService.deleteJob,
  { name }
))

export const reducer = asyncReducer(nameJob)
export const selector = asyncSelector(nameJob)



// WEBPACK FOOTER //
// ./src/store/jobs/deleteJob.js